import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=1dd449dc&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=1dd449dc&prod&lang=scss"
import style1 from "./Modal.vue?vue&type=style&index=1&id=1dd449dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd449dc",
  null
  
)

export default component.exports